import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { refreshToken } from 'actions/users';

export default function(ComposedComponent, allowedPermissions) {
  class Authentication extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    constructor(props) {
      super(props);
      this.state = { shouldRender: false };
    }

    componentDidMount() {
      this.props.refreshToken();
      if (
        !this.props.appUser ||
        (allowedPermissions.length !== 0 &&
          !this.props.appUser.permissions.some(permission =>
            includes(allowedPermissions, permission)
          ))
      ) {
        this.props.history.goBack();
        return;
      }
      this.setState({ shouldRender: true });
    }

    componentDidUpdate() {
      if (
        !this.props.appUser ||
        (allowedPermissions.length !== 0 &&
          !this.props.appUser.permissions.some(permission =>
            includes(allowedPermissions, permission)
          ))
      ) {
        this.props.history.goBack();
        return;
      } else {
        if (!this.state.shouldRender) {
          this.setState({ shouldRender: true });
        }
      }
    }

    render() {
      return this.state.shouldRender ? (
        <ComposedComponent {...this.props} />
      ) : null;
    }
  }

  function mapStateToProps(state) {
    return { appUser: state.auth.appUser };
  }

  return connect(
    mapStateToProps,
    { refreshToken }
  )(Authentication);
}
